// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BRdk","clinicsSelect":"styles_clinicsSelect__32mlD"};